<template>
<b-overlay :show="show" rounded="sm">
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">Relacionar Conferências</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4">
        <b-form-group label="Conferência:">
          <b-form-select v-model="form.conferencia_relacionada_id" :options="conferencias" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">
        <b-button @click="adicionarConferencia" block variant="primary">
          <i class="fa fa-plus"></i>
          <span>Adicionar</span>
        </b-button>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col>
        <b-table selectable select-mode="multi" id="conferenciasRelacionadas" :fields="campos" :items="conferenciasRelacionadas" :per-page="10" :current-page="1" small bordered outlined>
          <template #cell(nome)="data">{{data.item.nome}} - {{data.item.sigla}}</template>
          <template #cell(id)="data">
            <b-button title="Remover" @click="removerConferencia(data.item.id)">
              <i class="fa fa-trash" style="color: black"/>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>&nbsp;</b-col>
    </b-row>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="9">
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="navigate('/configurarConferencia/gerenciar')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
  </b-container>  
</b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'

export default {
  data () {
    return {
      campos: [
        {key: 'nome', label: 'Nome da Conferência - Sigla', sortable: false},
        {key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro'}
      ],
      show:false,
      form: {
        conferencia_relacionada_id: null
      }
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      conferencias: state => state.usuario.conferencias,
      conferenciasRelacionadas: state => state.conferencia.conferenciasRelacionadas,
    })
  },
  mounted () {
    this.$store.dispatch('getConferenciasUser')
    this.$store.dispatch('setConferenciasRelacionadas', SessionStorage.get('conferencia_atual_id'))
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    adicionarConferencia () {
      if(this.form.conferenciasRelacionadas === null) {
        this.erro('Infome a conferência que deseja relacionar!')
        return false;
      }
      this.show = true
      Vue.http.post('api/conferencia/relacionada', {
        'conferencia_relacionada_id': this.form.conferencia_relacionada_id
      }).then(response => {
        this.show = false
        if(response.body.success) {
          this.sucesso(response.body.msg)
        }else{
          this.erro(response.body.msg)
        }
        this.$store.dispatch('setConferenciasRelacionadas', SessionStorage.get('conferencia_atual_id'))
      })
    },
    removerConferencia (conferencia_relacionada_id) {
      Vue.http.delete('api/conferencia/relacionada/' + conferencia_relacionada_id).then(response => {
        if(response.body.success) {
          this.sucesso(response.body.msg)
        }else{
          this.erro(response.body.msg)
        }
        this.$store.dispatch('setConferenciasRelacionadas', SessionStorage.get('conferencia_atual_id'))
      }).catch(e => {
        this.erro(e.body.msg)
      })
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    alerta (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Alerta',
        autoHideDelay: 30000,
        appendToast: true,
        variant: 'warning'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Relacionar.vue